import React from 'react';

export const NotFound = React.memo(() => (
  <p>Not Found.</p>
));